(function() {
'use strict';

  angular
    .module('app')
    .controller('nextMenuDetailController', nextMenuDetailController);

  function nextMenuDetailController(viewModel) {
    var vm = this;
    vm.data=viewModel.data;
  }
})();